/**
 * KAN-997: бейдж "Был под флудом" с датами первого и последнего эпизода
 * и числом эпизодов в подсказке. У непомеченных аккаунтов ничего.
 */
import { FLOOD_BADGE_TEXT, floodBadgeTitle, type FloodMarkFields } from '@/lib/telegramFlood';

export function FloodBadge({ account }: { account: FloodMarkFields }): JSX.Element | null {
  if (!account.flood_flagged) return null;
  return (
    <span
      className="mt-1 w-fit whitespace-nowrap rounded bg-orange-100 px-1.5 py-0.5 text-xs font-normal text-orange-800"
      data-testid="flood-badge"
      title={floodBadgeTitle(account)}
    >
      {FLOOD_BADGE_TEXT}
    </span>
  );
}
